import { fetch } from '@atlassian/eoc-fetch';

import { urls } from '../../../common/constants';
import type { OpsTeamsResponse } from '../../../common/types';

export const getOpsTeamsEndpoint = (): Promise<OpsTeamsResponse> => {
	return fetch<OpsTeamsResponse>(urls.teams.url());
};
